<template>
  <div id="cont">
    <div id="colored" :class="{'visible': isActive, 'hidden': notActive}">
      {{lowerCaseTitle}}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NavHighlight',
    
    props: {
      linkTitle: String
    },

    computed: {
      lowerCaseTitle() {
        return this.linkTitle.toLowerCase();
      },

      activeSections() {
        return this.$store.state.activeSections;
      },

      isActive() {
        if (this.activeSections[this.lowerCaseTitle]) {
          return true;
        } return false;
      },

      notActive() {
        if (!this.activeSections[this.lowerCaseTitle]) {
          return true;
        } return false;
      }
    }
  }
  
</script>

<style scoped>
  #colored {
    background-color: var(--nav-highlight);
    height: 20px;
    border-radius: 10px;
    transition: all 350ms cubic-bezier(.47,0,.2,1);
    opacity: 0px;
  }

  #cont {
    font-size: 16px;
    font-family: Futura,Trebuchet MS,Arial,sans-serif; 
    color: rgba(255,255,255, 0);
    text-decoration: none;
    display: flex;
    margin: 0px 15px 0px 15px;
    border: dotted green 0px;
  }

  .visible {
    transform: translateY(0px);
  }
  
  .hidden {
    transform: translateY(15px);
  }

</style>